var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".error{text-align:center;padding-top:150px}.error-img{width:292px;height:189px;background:url(" + escape(require("@/assets/img/page_error.png")) + ") no-repeat;margin:auto}.error-tip{font-size:18px;color:#606060;margin-top:10px}", "", {"version":3,"sources":["/home/workspace/nr-api-html/master/src/components/common/NotFound.vue"],"names":[],"mappings":"AACA,OACE,kBAAmB,AACnB,iBAAmB,CACpB,AACD,WACI,YAAa,AACb,aAAc,AACd,mDAAwD,AACxD,WAAa,CAChB,AACD,WACI,eAAgB,AAChB,cAAe,AACf,eAAiB,CACpB","file":"NotFound.vue","sourcesContent":["\n.error {\n  text-align: center;\n  padding-top: 150px;\n}\n.error-img {\n    width: 292px;\n    height: 189px;\n    background: url(~@/assets/img/page_error.png) no-repeat;\n    margin: auto;\n}\n.error-tip {\n    font-size: 18px;\n    color: #606060;\n    margin-top: 10px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a8fbf0fc","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/NotFound.vue
// module id = 563
// module chunks = 7